document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("sku-search");
  if (!searchInput) return;

  const productGroups = document.querySelectorAll('[data-testid="group-block"]');

  // Create the "no results" message element
  const noResultsMessage = document.createElement("div");
  noResultsMessage.textContent = "No products match your search. Try using different keywords or filters.";
  noResultsMessage.style.display = "none";
  noResultsMessage.style.marginTop = "20px";
  noResultsMessage.style.fontStyle = "italic";
  noResultsMessage.style.color = "#999"; // light gray text
  searchInput.parentNode.insertBefore(noResultsMessage, searchInput.nextSibling);

  searchInput.addEventListener("keyup", function () {
    const query = this.value.toLowerCase();
    let anyVisible = false;

    productGroups.forEach(group => {
      const nameBlock = group.querySelector('[class*="__text_NAME"]');
      const skuBlock  = group.querySelector('[class*="__text_SKU"]');

      const nameText = nameBlock ? nameBlock.innerText.toLowerCase() : "";
      const skuText  = skuBlock ? skuBlock.innerText.toLowerCase() : "";

      if (nameText.includes(query) || skuText.includes(query)) {
        group.style.display = "";
        anyVisible = true;
      } else {
        group.style.display = "none";
      }
    });

    // Show message if nothing is visible
    noResultsMessage.style.display = anyVisible ? "none" : "block";
  });
});
